import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from '../../constants';

export interface Role {
  id: string;
  name: string;
}
@Injectable({ providedIn: 'root' })
export class RoleService {
  private apiUrl = `${baseUrl}Roles`;

  constructor(private http: HttpClient) {}

  private get headers() {
    const token = localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }),
    };
  }

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(this.apiUrl, this.headers);
  }

  getRoleById(id: string): Observable<Role> {
    return this.http.get<Role>(`${this.apiUrl}/${id}`, this.headers);
  }

// IMPORTANT: This now expects the backend to return the created role object, e.g., { id: '...', name: '...' }
createRole(role: { name: string }): Observable<Role> {
  const payload = { name: role.name };
  return this.http.post<Role>(`${this.apiUrl}`, payload, this.headers);
}

  updateRole(id: string, role: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, role, {
      ...this.headers,
      observe: 'response',
      responseType: 'text',
    } as any);
  }
    /**
   * Assigns a list of permission IDs to a specific role.
   * @param roleId The unique identifier of the role.
   * @param permissionIds An array of numbers representing the permission IDs.
   */
    assignPermissionsToRole(roleId: string, permissionIds: number[]): Observable<any> {
      const endpoint = `${this.apiUrl}/${roleId}/permissions`;
      return this.http.post(endpoint, permissionIds, this.headers);
    }

  deleteRole(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {
      ...this.headers,
      observe: 'response',
      responseType: 'text',
    } as any);
  }
}
